import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
// Onboarding responses are legacy, versioned payloads shared with the
// learner app; response fields will be tightened in a dedicated follow-up.
const LegacyObjectResponse = z.object({}).passthrough();
export const saveProsumerOnboardingRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/onboarding/save',
    name: 'save-prosumer-onboarding',
    request: {
        body: z.object({
            // Steps are client-defined by the onboarding flow and vary by version.
            onboardingSteps: z.array(z.object({}).passthrough()),
            email: z.string().email(),
            partnerSignupCode: z.string().nullable(),
            projectSlug: z.string().nullable(),
        }),
    },
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
export const finishProsumerOnboardingRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/onboarding/finish',
    name: 'finish-prosumer-onboarding',
    request: {},
    responses: { 200: LegacyObjectResponse, 400: HttpErrorResponse },
};
const RedeemProsumerPartnerCodeResponse = z.object({
    code: z.string(),
    welcomeMessage: z.string(),
    /** ISO timestamp. */
    proUntil: z.string().nullable(),
    alreadyRedeemed: z.boolean(),
});
export const redeemProsumerPartnerCodeRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/partner-codes/redeem',
    name: 'redeem-prosumer-partner-code',
    request: {
        body: z.object({ code: z.string().min(1).max(200) }),
    },
    responses: {
        200: RedeemProsumerPartnerCodeResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const joinProsumerContentRoute = {
    version: 1,
    method: 'POST',
    path: '/prosumer/content',
    name: 'join-prosumer-content',
    request: {
        body: z.object({ contentId: z.coerce.number().int().positive() }),
    },
    responses: {
        200: z.object({
            next_mission_slug: z.string(),
            next_activity_slug: z.string(),
        }),
        400: HttpErrorResponse,
    },
};
